import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';
import { Field } from 'redux-form-normalize-on-blur';
import Fade from './../Fade';
import InfoLink from '../InfoLink';

export default class FormField extends Component {
  static propTypes = {
    children: PropTypes.node,
    name: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
    required: PropTypes.bool,
    component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    type: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    inputProps: PropTypes.object,
    maxLength: PropTypes.number,
    onFocusTip: PropTypes.string,
    prefix: PropTypes.string,
    prefixPattern: PropTypes.instanceOf(RegExp),
    simple: PropTypes.bool,
    clearMargin: PropTypes.bool,
    autoComplete: PropTypes.string,
    infoUrl: PropTypes.string
  };

  static defaultProps = {
    error: null,
    maxLength: -1,
    simple: false,
    clearMargin: false,
    onBlur: null,
    infoUrl: null
  };

  wrapper = (component, inputProps = {}) => {
    const {
      name,
      label,
      error,
      required,
      clearMargin,
      infoUrl,
      subtextComponent
    } = this.props;

    const onFocusTipVisible = this.props.onFocusTip && inputProps.meta.active;
    const errorVisible = !!error &&
      (
        Object.keys(inputProps).length === 0 ||
        inputProps.meta.touched && !inputProps.meta.asyncValidating
      )
      && !onFocusTipVisible;
    const moreInfoVisible = onFocusTipVisible || this.props.maxLength > -1 || errorVisible;

    return (
      <FormGroup className={clearMargin ? 'm-0' : ''}>
        {label && <Label for={name}>{label}{required && <span className="text-danger"> *</span>}
          {infoUrl && <InfoLink link={infoUrl}/>}
        </Label>
        }
        {subtextComponent}
        {component}
        {moreInfoVisible && <div className="row justify-content-between mt-1 font-weight-light">
          <div className="col">
            <Fade in={onFocusTipVisible || errorVisible}>
              {onFocusTipVisible && <span className="form-text--matching">{this.props.onFocusTip}</span>}
              {errorVisible && <span className="text-danger">{error}</span>}
            </Fade>
          </div>
          <div className="col-3 col-md-2 text-right">
            {this.props.maxLength > -1 && `${inputProps.input.value.length}/${this.props.maxLength}`}
          </div>
        </div>}
      </FormGroup>
    );
  }

  wrappedComponent = (inputProps) => {
    const onChange = (event) => {
      if (this.props.prefixPattern && this.props.prefix) {
        if (!this.props.prefixPattern.test(event.target.value) && event.target.value.length !== 0) {
          return inputProps.input.onChange(this.props.prefix + event.target.value);
        }
      }

      inputProps.input.onChange(event);
    };

    const onBlur = (event) => {
      const { relatedTarget } = event;
      if (relatedTarget && (relatedTarget.getAttribute('type') === 'button')) {
        event.preventDefault();
      } else {
        inputProps.input.onBlur(event);
      }
    };

    const componentProps = {
      placeholder: this.props.placeholder,
      autoComplete: this.props.autoComplete,
      type: inputProps.type,
      ...inputProps.input,
      ...this.props.inputProps,
      onChange,
      onBlur
    };
    if (this.props.error && inputProps.meta.touched && !inputProps.meta.asyncValidating) {
      componentProps.className = `${inputProps.className} is-invalid`;
    }

    let component = null;
    if (typeof this.props.component === 'string') {
      component = React.createElement(this.props.component, { className: 'form-control', ...componentProps });
    } else {
      component = this.props.component(inputProps, this.props.error, componentProps);
    }

    if (this.props.simple) {
      return component;
    }

    return this.wrapper(component, inputProps);
  }

  render() {
    const {
      name,
      className,
      children
    } = this.props;

    if (children) {
      return this.wrapper(children);
    }

    return (
      <Field
        {...this.props}
        name={name}
        className={className}
        component={this.wrappedComponent}
      />
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/FormField.jsx